// URL del API según el ENTORNO (no tocar a mano): la define REACT_APP_API_URI.
//   - npm start  → .env.development  (http://localhost:8000)
//   - npm run build → .env.production (https://api.tusclasesdeguitarra.com)
// El default es PROD, así que un build sin .env igual apunta bien.
export const API_URI = process.env.REACT_APP_API_URI || 'https://api.tusclasesdeguitarra.com';

export function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}